<div [style.background]="this.backgroundColor"
     [style.color]="this.foregroundColor"
     class="opg-price-column-cell-renderer"
>
  <span>{{ this.price }}</span>
  <span *ngIf="this.qty"> ({{ this.qty > 0 ? '+' : '' }}{{ this.qty }})</span>
  <span *ngIf="this.calendarized" class="dow">{{ this.dow }}</span>
</div>